import ScrollInput from './ScrollInput';
import Resize from './Resize';
import Subject from './Subject';

export default class WindowApp {
	constructor() {
		this.scrollInput = new ScrollInput();
		this.menuVisible = new Subject(this.pageId);
		this.scrollPos = new Subject(0);
		this.caseBG = new Subject('');
		this.changeBackground = new Subject(false);
		this.moveBackground = new Subject(false);
	}
}
